<h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Jobs</h2>
<button class="btn btn-success btn-sm" (click)="exportToExcel(jobs)">Download .xlsx ({{ status }})</button>

<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'project_id'">Job</clr-dg-column>
    <clr-dg-column>aus Angebot</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Kunden</clr-dg-column>
    <clr-dg-column class="currency">VK netto</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_date'">
        <ng-container *clrDgHideableColumn="{ hidden: true }">
            Auftragsdatum
        </ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'delivery_date'" [clrDgSortOrder]="descSort">Lieferdatum</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Job!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let job of jobs" [routerLink]="['/job/details/', job.project_id, job.job_id]">
        <clr-dg-cell>{{ job.project_id }}.0006.{{ job.job_id }}</clr-dg-cell>
        <clr-dg-cell *ngIf="job.offer_id > 0" [routerLink]="['/offer/details', job.project_id, job.offer_id]">{{ job.project_id }}.0003.{{ job.offer_id }}</clr-dg-cell>
        <clr-dg-cell *ngIf="job.offer_id == 0" >---</clr-dg-cell>
        <clr-dg-cell><b>{{ job.name_project }}</b></clr-dg-cell>
        <clr-dg-cell>{{ job.company_name }}</clr-dg-cell>
        <clr-dg-cell>{{ job.order_id }}</clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ job.budget | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
        <!--<clr-dg-cell class="currency">{{ calculateEk(job.project_id, job.job_id) }} {{ calculateVk(job.project_id, job.job_id) }}{{ job.budget | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>-->
        <clr-dg-cell>{{ job.job_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
        <clr-dg-cell><span *ngIf="job.delivery_date !== '0000-00-00'">{{ job.delivery_date | date: "dd.MM.yyyy" }}</span></clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(job.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">{{ getCellStatus(job.status).statusDisplay}}</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von {{jobs.length}} Job(s)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
